import { Input, InputItem } from "components";
/**
* Bug #502
* @Author Linda Susan Raju
* @Date 15 Jul 2021
*/
const Password = ({ label = null, name = null, errorMessage = null, hasFeedback = false, validationNeeded = false, dependencies = [],
    compareConfirmationWith = null, placeholder = null, ...props }) => {

    const passwordValidation = (rule, value, callback) => {
        if ((value) && !((/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,150}$/.test(value)))) {
            callback('Password requires minimum 8 characters which contain at least one uppercase alphabet, one numeric digit and a special character');
        } else {
            callback();
        }
    };

    return (
        <InputItem label={label} name={name} className="form-control-psw-group" hasFeedback={hasFeedback} dependencies={dependencies}
            rules={[{ required: true, message: errorMessage }, { validator: validationNeeded ? passwordValidation : null },
            ({ getFieldValue }) => ({
                validator(_, value) {
                    if (!value || !compareConfirmationWith || getFieldValue(compareConfirmationWith) === value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error('The two passwords that you entered do not match!'));
                },
            }),
            ]}>
            <Input.Password className="form-control-psw " placeholder={placeholder} />
        </InputItem>
    )
}
export default Password;
/**End Bug#502 */